import { actions } from './actions'

const initialState = {
  data: [],
}

export default function printableReducer(state = initialState, action) {
  switch (action.type) {
    case actions.LOAD_PRINTABLE_RESULT:
      return { ...state, data: action.payload.data }
    default:
      return state
  }
}
